import React from 'react';
import { Mountain, Heart, Target, Users } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => {
  return (
    <div className="min-h-screen">
      <div 
        className="relative py-20"
      >
        <Header />
        <div className="max-w-4xl mx-auto px-4 sm:px-6 pt-32 sm:pt-44 lg:pt-52 pb-4 text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4">O projektu WildCamping</h1>
          <p className="text-xl text-white/90">
            Spojujeme milovníky přírody s nejkrásnějšími divokými místy
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-6 py-20">
        {/* Mission */}
        <section className="mb-20 bg-white/95 backdrop-blur-md rounded-2xl p-10 shadow-2xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6">Naše mise</h2>
              <p className="text-lg text-gray-700 leading-relaxed mb-4">
                WildCamping vznikl z lásky k přírodě a touhy sdílet úžasná místa pro divoké kempování s ostatními nadšenci. Věříme, že každý by měl mít možnost zažít klid a krásu divočiny.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Naším cílem je vytvořit udržitelnou platformu, která spojuje majitele pozemků s kempaři, podporuje odpovědný turismus a pomáhá chránit přírodní prostředí pro budoucí generace.
              </p>
            </div>
            <div>
              <img
                src="https://images.pexels.com/photos/12913674/pexels-photo-12913674.jpeg"
                alt="Camping in nature"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </section>

        {/* Values */}
        <section className="mb-20">
          <h2 className="text-3xl font-bold text-center mb-12 text-white drop-shadow-lg">Naše hodnoty</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <ValueCard
              icon={<Mountain className="w-12 h-12" />}
              title="Příroda na prvním místě"
              description="Respektujeme a chráníme přírodní prostředí ve všech našich činnostech."
            />
            <ValueCard
              icon={<Heart className="w-12 h-12" />}
              title="Komunita"
              description="Budujeme vstřícnou komunitu milovníků outdooru a divočiny."
            />
            <ValueCard
              icon={<Target className="w-12 h-12" />}
              title="Autenticita"
              description="Nabízíme pravé outdoorové zážitky daleko od davů a civilizace."
            />
            <ValueCard
              icon={<Users className="w-12 h-12" />}
              title="Důvěra"
              description="Vytváříme bezpečné prostředí postavené na vzájemné důvěře a respektu."
            />
          </div>
        </section>

        {/* Story */}
        <section className="bg-white rounded-2xl p-12 shadow-lg mb-20">
          <h2 className="text-3xl font-bold mb-6 text-center">Náš příběh</h2>
          <div className="max-w-3xl mx-auto space-y-4 text-gray-700 leading-relaxed">
            <p>
              WildCamping začal jako jednoduchý nápad během výpravy do divočiny v roce 2024. Skupina přátel hledala ideální místo pro kempování, ale většina dostupných informací byla roztříštěná nebo neaktuální.
            </p>
            <p>
              Uvědomili jsme si, že existuje potřeba platformy, která by spojovala majitele krásných, odlehlých pozemků s lidmi hledajícími autentické outdoorové zážitky. A tak se zrodil WildCamping.
            </p>
            <p>
              Od našeho spuštění jsme vyrostli do komunity tisíců kempařů a stovek úžasných míst po celé zemi. Každý den pomáháme lidem objevovat nová dobrodružství a vytvářet nezapomenutelné vzpomínky v přírodě.
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

const ValueCard = ({ icon, title, description }) => (
  <Card className="text-center hover:shadow-lg transition-all duration-300 group">
    <CardContent className="p-6">
      <div className="text-orange-600 flex justify-center mb-4 group-hover:scale-110 transition-transform">
        {icon}
      </div>
      <h3 className="text-xl font-bold mb-3">{title}</h3>
      <p className="text-gray-600">{description}</p>
    </CardContent>
  </Card>
);

export default About;
